const SimulationCustomerGranteesExtraFormCfeRepresentative = () => null;

export default SimulationCustomerGranteesExtraFormCfeRepresentative;
